/**
 * The harvest strip (ADR-142's amendment of 2026-10-31): the loop a character shows while a harvest hold runs, cut from
 * the sword's first slash with a sickle in the hand. A page loops it for the whole hold, for the character's own hold from the
 * server's `hold` and for every other character from the harvest state in its animation bits.
 */

/**
 * The strip's name.
 */
export const HARVEST_STRIP = "harvest";

/**
 * The frame of the strip at which the blow lands: the strip is the first slash's, three frames of its wind-up and then
 * its blow, so each round of the loop reaches the blow at this frame, where a page shakes the prop and throws its
 * leaves.
 */
export const HARVEST_GRAB_FRAME = 3;

/**
 * How many frames the strip has in each direction.
 */
export const HARVEST_STRIP_FRAMES = 8;
